import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethree-approach',
  templateUrl: './homethree-approach.component.html',
  styleUrls: ['./homethree-approach.component.scss']
})
export class HomethreeApproachComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
